import { BorrowerLendingLimitTableType } from '../tables/BorrowerLendingLimitTableType';
import { BorrowerLendingLimitTableDefinition } from '../tables/BorrowerLendingLimitTableDefinition';

export const getInfoBubble = <TColumn extends string, TRowValue extends string>(
    tableType: BorrowerLendingLimitTableType,
    field: TColumn,
    value: TRowValue
): string => {
    const table = BorrowerLendingLimitTableDefinition[tableType];
    if (!table) return '';

    const def = table.find((col) => col.field === field);
    if (!def || !def.infoBubble) return '';

    // Case 1: simple string
    if (typeof def.infoBubble === 'string') {
        return def.infoBubble;
    }

    // Case 2: row‑dependent map
    return def.infoBubble[value] ?? '';
};
